import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { Router } from '@angular/router'
import {
  DataContextBuilder,
  ElderBasicPaneLayoutComponent,
  ElderDataToolbarComponent,
  ElderPaneComponent,
  ElderSearchBoxComponent,
  ElderSearchContextDirective,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderToolbarContentDirective,
  IDataContext,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { PackageType } from '../package-type'
import { PackageTypeService } from '../package-type.service'

@Component({
  selector: 'app-package-type-browser',
  templateUrl: './package-type-browser.component.html',
  styleUrls: ['./package-type-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    ElderToolbarContentDirective,
    ElderSearchBoxComponent,
    ElderSearchContextDirective,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class PackageTypeBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<PackageType>
  private router = inject(Router)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const typeService = inject(PackageTypeService)
    this.data = DataContextBuilder.start<PackageType>()
      .pageSize(50)
      .reloadOnLocalChanges()
      .autoStartAsap()
      .build(typeService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openDetail(type: PackageType): void {
    this.router.navigate([{ outlets: { side: ['packages', 'types', type.id] } }], {
      preserveFragment: true,
    })
  }

  createNew(): void {
    this.router.navigate([{ outlets: { side: ['packages', 'types', 'new'] } }], {
      preserveFragment: true,
    })
  }
}
